import { Spin } from 'antd';

export default (
    <Spin
        size="large"
        tip="loading..."
    >
        <div className="full-loading-spin"></div>
    </Spin>
);
